import React from 'react'
import styles from './CheckboxInput.module.scss'

type Size = 'xs' | 'sm' | 'md'

interface CheckboxInputProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  size?: Size
  disabled?: boolean
  className?: never
}

const sizeMap: Record<Size, string> = { xs: styles.xs, sm: styles.sm, md: styles.md }

export const CheckboxInput: React.FC<CheckboxInputProps> = ({
  checked, onChange, label, size = 'sm', disabled = false,
}) => (
  <label className={styles.wrapper}>
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      disabled={disabled}
      className={[styles.checkbox, sizeMap[size]].join(' ')}
    />
    {label && <span className={styles.label}>{label}</span>}
  </label>
)
